import { z } from "zod";

export const emailSchema = z
  .string()
  .trim()
  .min(1, "Email is required")
  .email("Invalid email address")
  .max(255, "Email must be less than 255 characters");

export const passwordSchema = z
  .string()
  .min(6, "Password must be at least 6 characters")
  .max(128, "Password must be less than 128 characters");

export const displayNameSchema = z
  .string()
  .trim()
  .min(1, "Display name is required")
  .max(100, "Display name must be less than 100 characters");

export const authSignupSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
  displayName: displayNameSchema,
});

export const authLoginSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
});

export const profileBioSchema = z
  .string()
  .trim()
  .min(1, "Bio is required")
  .max(2000, "Bio must be less than 2000 characters");

export const customTextSchema = z
  .string()
  .trim()
  .max(100, "Text must be less than 100 characters")
  .regex(/^[a-zA-Z0-9\s\-&.,()]+$/, "Only letters, numbers, spaces and common punctuation allowed");

export const organizationSchema = z
  .string()
  .trim()
  .min(1, "Organization is required")
  .max(200, "Organization must be less than 200 characters");

export const phoneSchema = z
  .string()
  .trim()
  .min(1, "Phone number is required")
  .regex(/^[\d\s\-+()]+$/, "Invalid phone number format")
  .max(20, "Phone number must be less than 20 characters");
